// see: https://github.com/chakra-ui/chakra-ui/blob/%40chakra-ui/react%402.2.1/packages/theme/src/components/input.ts
// see: https://zenn.dev/tokutsu/articles/edd55fd6c0e7a9

import { floatingControlHeight } from './form'

export const inputTheme = {
    baseStyle: {
        field: {
            _disabled: {
                bg: 'tryt.gray-2',
            },
            _groupDisabled: {
                opacity: 1,
            },
            _placeholder: {
                color: 'tryt.gray-4', 
            },
        },
    },
    variants: {
        outline: {
            field: {
                bg: 'white',
            },
            _hover: {
                borderColor: 'tryt.gray-4',
            },
        },
    },
    sizes: {
        md: {
            field: {
                fontSize: 'sm',
                fontFamily: 'fonts',
            },
        },
        floating: {
            field: {
                h: floatingControlHeight,
                fontFamily: 'fonts',
                borderRadius: 'md',
                fontSize: '14px',
                px: '8.5px',
                py: '16px',
            },
        },
    },
    defaultProps: {
        focusBorderColor: 'tryt.primary-1',
        fontFamily: 'fonts',
    },
}
